import React, { useEffect, useState } from "react";

import logo from "../../assets/images/logo.png";
import racehorse from "../../assets/images/testimonial-racehorse.png";

const reviews = [
	{
		quote: "Championbred has become a very useful tool for us at the sales. It helps us work through the catalogues, identify pedigrees worth a closer look and gives you a bit more confidence when the data lines up with what you see in the horse.",
		name: "Brad Spicer",
	},
	{
		quote: "The results have been encouraging: four of the 12 horses I own are already stakes winners, and I believe two more have the potential to join them. That is a current stakes-winner rate of 33%, with the possibility of reaching 50%. For me, Championbred has become a useful part of the process of finding exciting horses for the future.",
		name: "Axel Melbye",
	},
];

function DashboardTestimonial() {
	const [activeReview, setActiveReview] = useState(0);
	const [reviewVisible, setReviewVisible] = useState(true);

	useEffect(() => {
		let transitionTimeout;
		const interval = window.setInterval(() => {
			setReviewVisible(false);
			transitionTimeout = window.setTimeout(() => {
				setActiveReview((current) => (current + 1) % reviews.length);
				setReviewVisible(true);
			}, 300);
		}, 7000);

		return () => {
			window.clearInterval(interval);
			window.clearTimeout(transitionTimeout);
		};
	}, []);

	const review = reviews[activeReview];

	return (
		<figure className="dashboard-testimonial" aria-label="ChampionBred customer review">
			<div className="dashboard-testimonial__brand">
				<img src={logo} alt="ChampionBred" />
			</div>
			<blockquote className={`dashboard-testimonial__review${reviewVisible ? "" : " dashboard-testimonial__review--changing"}`} aria-live="polite" aria-atomic="true">
				<span className="dashboard-testimonial__quote dashboard-testimonial__quote--open" aria-hidden="true">“</span>
				<p>{review.quote}</p>
				<span className="dashboard-testimonial__quote dashboard-testimonial__quote--close" aria-hidden="true">”</span>
				<footer><cite>{review.name}</cite></footer>
			</blockquote>
			<img className="dashboard-testimonial__horse" src={racehorse} alt="" aria-hidden="true" loading="lazy" decoding="async" />
			<figcaption className="dashboard-testimonial__motto">Helping you find the <strong>Best Horses</strong></figcaption>
		</figure>
	);
}

export default DashboardTestimonial;
